// SILL-537 M5 (vf-shape-editable): buyer-facing labels for the six
// canonical income_shape values (backend model.ValidIncomeShapes,
// backend/internal/model/income_shape.go). Deliberately reuses the
// funnel's own How-you-earn vocabulary (income-shape-vocabulary.ts) so the
// question isn't phrased two different ways across the funnel and the
// Passport row — five of the six values come straight from
// HOW_YOU_EARN_CARDS; "other" is only ever reached via the funnel's
// not-employed refinement fork (never a direct how-you-earn card), so its
// label is pinned here to match that fork's "Something else" copy
// (ShapeDetailSection.tsx NOT_EMPLOYED_REFINEMENT_OPTIONS).
import { HOW_YOU_EARN_CARDS } from "../../../funnel/income-shape-vocabulary";

export const INCOME_SHAPE_OTHER_LABEL = "Something else";

export const INCOME_SHAPE_LABELS: Record<string, string> = {
  ...Object.fromEntries(
    HOW_YOU_EARN_CARDS.map((card) => [card.incomeShape, card.title]),
  ),
  other: INCOME_SHAPE_OTHER_LABEL,
};

export const INCOME_SHAPE_ITEMS: Array<{ label: string; value: string }> = [
  ...HOW_YOU_EARN_CARDS.map((card) => ({
    label: card.title,
    value: card.incomeShape as string,
  })),
  { label: INCOME_SHAPE_OTHER_LABEL, value: "other" },
];

export function incomeShapeLabel(shape: string): string {
  return INCOME_SHAPE_LABELS[shape] ?? shape;
}
